<template>
  <div id="app" v-bind:class="[
    { 'forside' : $route.path == '/' }, 
    { 'konferanse' : $route.path == '/dagmoter' },
    { 'konferanse' : $route.path == '/konferanse' }, 
    [ { 'pizzeria' : $route.path == '/pizzeria-del-generale' || $route.path == '/meny'} ], 
    [ { 'lobby' : $route.path == '/om-oss/bedriften' || $route.path == '/om-oss/jobb' || $route.path =='/om-oss/yrke' || $route.path == '/om-oss/kontakt' || $route.path == '/om-oss/personvern' || $route.path == '/om-oss/veien-hit' || $route.path == '/opplevelser/spill' || $route.path == '/opplevelser/aktiviteter' }], 
    { 'selskap' : $route.path == '/selskap' || $route.path == '/catering' || $route.path == '/blogg' }  ]">
      <my-header v-if="!sjekkUrl"></my-header>
      <router-view />
      <my-footer v-if="!sjekkUrl"></my-footer>
  </div>
</template>

<script>
import ogImage from '@/assets/images/illustrasjoner/resepsjonist_432px.jpg'

export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    //title: 'Hotell og italiensk restaurant i Hønefoss / Hole',
    // all titles will be injected into this template
    titleTemplate: '%s | General Hotell',
    meta: [
      {property: 'og:image', content: 'http://www.generalhotell.no' + ogImage }
    ]
  },
  computed: {
    sjekkUrl() {
      return this.$route.name === 'Smittevern' || this.$route.name === 'Smitte'  || this.$route.name === 'Konsept'
    }
  }
}
</script>

<style scoped>
.lobby {
    background-image: url('assets/images/illustrasjoner/valdrestunet.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover; 
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: auto;  
}

.selskap {
    background-image: url('assets/images/illustrasjoner/selskap.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover; 
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: auto;  
}

.pizzeria {
    background-image: url('assets/images/illustrasjoner/pizzeria.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover; 
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: auto;  
}

.konferanse {
    background-image: url('assets/images/illustrasjoner/conference.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover; 
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: auto;
}

.forside {
    background-image: url('assets/images/illustrasjoner/resepsjonist.jpg');
    background-position: center center;
    background-repeat: no-repeat;
    /* background-attachment: fixed;   */
    background-size: cover; 
    /* height: 100vh;
    width: 100%; */
    width: 100%;
    height: 100%;
    position: fixed;
/*     top: 0;
    left: 0; */
    overflow: auto;
}

/* Var 767px */
@media only screen and (max-width: 1024px) and (orientation: landscape) {
  .lobby {
    background-image: url('assets/images/illustrasjoner/valdrestunet_432px.jpg');    
  }

  .selskap {
    background-image: url('assets/images/illustrasjoner/selskap_432px.jpg');    
  }

  .pizzeria {
    background-image: url('assets/images/illustrasjoner/pizzeria_432px.jpg');    
  }

  .konferanse {
    background-image: url('assets/images/illustrasjoner/conference_432px.jpg');    
  }

  .forside {
    background-image: url('assets/images/illustrasjoner/resepsjonist_432px.jpg');    
  }
}


@media only screen and (max-width: 1024px) and (orientation: portrait) {
  .lobby {
    background-image: url('assets/images/illustrasjoner/valdrestunet_796px.jpg');    
  }

  .selskap {
    background-image: url('assets/images/illustrasjoner/selskap_796px.jpg');    
  }

  .pizzeria {
    background-image: url('assets/images/illustrasjoner/pizzeria_796px.jpg');    
  }

  .konferanse {
    background-image: url('assets/images/illustrasjoner/conference_796px.jpg');    
  }

  .forside {
    background-image: url('assets/images/illustrasjoner/resepsjonist_796px_portrait.jpg');    
  }
}
</style>


<style>
.quote {
  font-family: Georgia, serif;
  text-shadow: 1px 1px #000;
  line-height: 1.2 !Important;  
  
}


</style>





